// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminPanel.css */
:root {
  --sidebar-width: 200px;
  --primary-color: #007bff;
  --secondary-color: #f8f9fa;
  --text-color: #333;
  --active-bg: #e9ecef;
}

/* Ensure parent containers allow 100% height */
html, body, #root, .space-container, .content-container {
  height: 100%;

}

/* Root admin container: full height, no scroll */
.admin-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: var(--secondary-color);
}

/* Main area: sidebar + content */
.admin-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* Sidebar: fixed width, independent scroll */
.admin-sidebar {
  flex: 0 0 var(--sidebar-width);
  height: 100%;
  background-color: white;
  border-right: 1px solid #ddd;
  box-shadow: 2px 0 5px rgba(0,0,0,0.05);
  overflow-y: auto;
}

/* Content: fills remaining space, independent scroll */
.admin-content {
  flex: 1 1;
  height: 100%;
  overflow-y: auto;
  padding: 24px;
  background-color: var(--secondary-color);
  box-sizing: border-box;
}

/* Sidebar menu styles */
.admin-sidebar ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.admin-sidebar li {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.admin-sidebar li:hover {
  background-color: var(--active-bg);
}
.admin-sidebar li.active {
  background-color: var(--primary-color);
  color: white;
  font-weight: bold;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .admin-body {
    flex-direction: column;
  }
  .admin-sidebar {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #ddd;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminPanelExample/AdminPanel.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;;AAEd;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;EAC/B;AACF","sourcesContent":["/* AdminPanel.css */\r\n:root {\r\n  --sidebar-width: 200px;\r\n  --primary-color: #007bff;\r\n  --secondary-color: #f8f9fa;\r\n  --text-color: #333;\r\n  --active-bg: #e9ecef;\r\n}\r\n\r\n/* Ensure parent containers allow 100% height */\r\nhtml, body, #root, .space-container, .content-container {\r\n  height: 100%;\r\n\r\n}\r\n\r\n/* Root admin container: full height, no scroll */\r\n.admin-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  background-color: var(--secondary-color);\r\n}\r\n\r\n/* Main area: sidebar + content */\r\n.admin-body {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Sidebar: fixed width, independent scroll */\r\n.admin-sidebar {\r\n  flex: 0 0 var(--sidebar-width);\r\n  height: 100%;\r\n  background-color: white;\r\n  border-right: 1px solid #ddd;\r\n  box-shadow: 2px 0 5px rgba(0,0,0,0.05);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Content: fills remaining space, independent scroll */\r\n.admin-content {\r\n  flex: 1;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n  background-color: var(--secondary-color);\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Sidebar menu styles */\r\n.admin-sidebar ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.admin-sidebar li {\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.admin-sidebar li:hover {\r\n  background-color: var(--active-bg);\r\n}\r\n.admin-sidebar li.active {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Mobile responsiveness */\r\n@media (max-width: 768px) {\r\n  .admin-body {\r\n    flex-direction: column;\r\n  }\r\n  .admin-sidebar {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    border-right: none;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
